import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { closeModal } from '@/reducers/ui/ui.redux'
import { QACopilotPromptGenerationForm } from '@/views/QACopilot/forms/QACopilotPromptGenerationForm'

export const QACopilotPromptGenerationModal = ({ setFieldValue, criterionId }) => {
  const dispatch = useDispatch()
  const { currentlyOpenModalId } = useSelector((state) => state.ui)

  const modalId = 'qaCopilot/promptGeneration'
  const isOpen = currentlyOpenModalId === modalId

  const handleCloseModal = () => {
    dispatch(closeModal())
  }

  if (!isOpen) return null

  return (
    <BasicModal
      className="qa-copilot-prompt-generation-modal"
      title="Create QA Copilot Prompt"
      onClose={handleCloseModal}
      show={isOpen}
      size="small"
      scrolling
      footer=""
    >
      <QACopilotPromptGenerationForm
        setFieldValue={setFieldValue}
        criterionId={criterionId}
        onClose={handleCloseModal}
      />
    </BasicModal>
  )
}

export default QACopilotPromptGenerationModal
